<script lang="ts" setup>
import { onMounted, ref, useRoute, useRouter } from '#imports';
import { useService } from '@kaokei/use-vue-service';
import { getMyLastIncomplete } from '~/api/oj/my';
import { UserService } from '~/services/user.service';
import { dayHourMinuteGap } from '~/utils/utility';
import LastUnfinishedItem from './LastUnfinishedItem.vue';
import ModuleTitle from './ModuleTitle.vue';

const route = useRoute();
const router = useRouter();
const userService = useService(UserService);

const visible = ref(true);
const list = ref([] as any[]);

function getTimeLeft(start?: number, end?: number) {
  const now = new Date().getTime();
  if (start && now < start) {
    return `距开始 ${dayHourMinuteGap(now, start)}`;
  } else if (end && now < end) {
    return `距结束 ${dayHourMinuteGap(now, end)}`;
  } else {
    return '已结束';
  }
}

function init() {
  if (!userService.isLogin()) {
    return (visible.value = false);
  }
  getMyLastIncomplete()
    .then((res) => {
      if (res.problem) {
        const resolveRouter = router.resolve({
          name: 'oj_problem_detail',
          query: {
            pid: res.problem.pid || void 0,
            gid: res.problem.gid || void 0,
            tid: res.problem.tid || void 0,
          },
        });
        const item = {
          id: 'problem',
          tag: '在做题目',
          title: `${res.problem.problemId} ${res.problem.title}`,
          url: resolveRouter.href,
          status: res.problem.isAc ? '已通过' : '未通过',
          color: res.problem.isAc,
        };
        list.value.push(item);
      }

      if (res.training) {
        const resolveRouter = router.resolve({
          name: 'oj_training_detail',
          query: {
            gid: res.training.gid || void 0,
            tid: res.training.tid || void 0,
          },
        });
        const item = {
          id: 'training',
          tag: '在做题单',
          title: `${res.training.title}`,
          url: resolveRouter.href,
          status: `${res.training.acCount} / ${res.training.problemCount}`,
          color: res.training.acCount === res.training.problemCount,
        };
        list.value.push(item);
      }

      if (res.contest) {
        const resolveRouter = router.resolve({
          name: 'oj_contest_detail',
          query: {
            cid: res.contest.cid || void 0,
            gid: res.contest.gid || void 0,
          },
        });

        const item = {
          id: 'contest',
          tag: '最近比赛',
          title: `${res.contest.title}`,
          url: resolveRouter.href,
          status: getTimeLeft(res.contest.startTime, res.contest.endTime),
          color: false,
        };
        list.value.push(item);
      }

      if (list.value.length === 0) {
        visible.value = false;
      }
    })
    .catch((e) => {
      visible.value = false;
    });
}

onMounted(() => {
  init();
});
</script>

<template>
  <div v-if="visible" class="rounded border border-lightblack bg-white p-3">
    <ModuleTitle>
      <img src="~/assets/image/index/title/stjl.svg" alt="上次未完成" />
    </ModuleTitle>
    <div v-if="list.length == 0" class="mt-3">
      <a-skeleton />
    </div>
    <div v-else class="flex flex-col items-start justify-start">
      <template v-for="item in list" :key="item.id">
        <LastUnfinishedItem
          v-track:newoj_homepage_historyrecord_show="{ sub_type: item.id }"
          v-track:newoj_homepage_historyrecord_click.click="{
            sub_type: item.id,
          }"
          :data="item"
        ></LastUnfinishedItem>
      </template>
    </div>
  </div>
</template>
